export const crunch = window.crunch
